import moment from 'moment';

export default {

  alarmOffsetIdentifier(referenceDayOffset) {
    switch(referenceDayOffset) {
      case 0:
        return "On due date"
      case 1:
        return "1 day before"
      case 7:
        return "One week before"
      default:
        return referenceDayOffset + " days before"
    }

  },

  alarmBody(title, dueAt) {
    return title + " is due " + moment(dueAt).format('ll');
  },

  alarmFireDate(referenceDate, offset, oldFireDate) {
    var referenceMoment = moment(referenceDate);
    var oldFireMoment = moment(oldFireDate);

    var newFireMoment = referenceMoment.subtract(offset, 'days')
                         .hours(oldFireMoment.hours())
                         .minutes(oldFireMoment.minutes())
                         .seconds(oldFireMoment.seconds())
                         .milliseconds(oldFireMoment.milliseconds()); 

    return newFireMoment.toDate();
  }

}


// WEBPACK FOOTER //
// ./src/services/utils.js